// lib/list/factoryReferenceSecurity.ts
import { assetUrlFromAzureBlobUrl, FATER_PUBLIC_ASSET_ORIGIN, PUBLIC_ASSET_CONTAINERS, s3BucketHost } from '#lib/azure-shared';

/** The origins our own asset route answers on: our public files', the page's, and the configured public site. */
const ownOrigins = (): string[] => [
  FATER_PUBLIC_ASSET_ORIGIN,
  typeof window !== 'undefined' ? window.location.origin : undefined,
  process.env.NEXT_PUBLIC_SITE_URL,
  process.env.NEXT_PUBLIC_APP_URL,
].flatMap((value) => {
  if (!value) return [];
  try { return [new URL(value).origin]; } catch { return []; }
});

export const isAllowedFactoryReferenceUrl = (value: string): boolean => {
  // ponytail: a former Azure URL of ours, until scripts/storage/rewrite-azure-urls.ts has run; then delete this line.
  if (assetUrlFromAzureBlobUrl(value) !== null) return true;
  try {
    const url = new URL(value);
    // Our bucket is known to the server only: the browser keeps addressing these files on our origin.
    if (url.host === s3BucketHost()) return url.protocol === 'https:' && PUBLIC_ASSET_CONTAINERS.has(url.pathname.split('/')[1] ?? '');
    return url.pathname.startsWith('/api/assets/') && ownOrigins().includes(url.origin);
  } catch {
    return false;
  }
};
